const taskTypes = {
  APPROVAL: { name: 'Approval', guid: '3eb88f70-b41b-4764-9d5d-0de0752340e6' },
  AWS_LAMBDA: { name: 'AWS Lambda', guid: '4207f59d-61b7-4aec-9627-115637ee71b5' },
  COMMAND_LINE: { name: 'Command Line', guid: 'd9af0a65-80b8-4954-8639-0c65dfb74f66' },
  COUNTER: { name: 'Counter', guid: 'd58a7b66-cb8a-4d11-96d6-87589cc850f0' },
  DATA_CONTAINER: { name: 'Data Container', guid: '9b438c6d-9fa9-49d0-abfc-8bd153928422' },
  DATABASE_PULL: { name: 'Database Pull', guid: 'f66d2c1f-21ee-49a8-a8ca-3aa870a3ab77' },
  DATABASE_PUSH: { name: 'Database Push', guid: '169e6eee-efda-4ec4-87a3-a31c82ed544e' },
  DEVELOPER_FORM: { name: 'Developer Form', guid: 'dd235890-9dfe-11e2-8cd8-7dab4fba8719' },
  DOCX_TO_PDF_GENERATOR: { name: 'DocX To PDF Generator', guid: 'aeb14741-af2b-4031-b00e-a8b8c3c77493' },
  DYNAMIC_ASSIGNER: { name: 'Dynamic Assigner', guid: 'a07fe9c4-be8b-4435-acc0-936ed7c0efdf' },
  DYNAMIC_NOTIFICATION: { name: 'Dynamic Notification', guid: 'b9a3ff29-93e7-4de4-b5cd-3f6fbf3407a0' },
  EXCEL_BATCH: { name: 'Excel Batch', guid: '9e04cbb6-67f2-439d-8ef3-d7c304929096' },
  EXCEL_IMPORT: { name: 'Excel Import', guid: 'f9547bf6-46a7-4501-b19c-c284b13f0a18' },
  FORM: { name: 'Form', guid: 'b5aa194f-6a24-4c3e-949b-327413961ae8' },
  FORM_ASSIGNER: { name: 'Form Assigner', guid: 'e5407240-ba69-4a5d-a0a2-638e09ff6158' },
  FTP_PUSH: { name: 'FTP Push', guid: '6c625490-5628-4dd7-a0a6-d4341d1ee0fc' },
  GENERAL_NOTIFICATION: { name: 'General Notification', guid: '5ff9c103-405e-4a30-82be-35baadc8675f' },
  LAUNCH_REQUEST: { name: 'Launch Request', guid: '30baf3f9-59a2-4288-a1ce-e139447ff39e' },
  LOCAL_FILE_COPY: { name: 'File Copy', guid: '3903eccb-5a97-4d0b-8330-d49a360252f6' },
  MILESTONE: { name: 'Milestone', guid: '00d7a8be-94e0-4795-911c-a86b118e0bb4' },
  OPEN_API: { name: 'Open API', guid: 'e4ea31f1-5c2c-42d4-8dc1-1923c2f4e0e2' },
  OPEN_URL: { name: 'Open URL', guid: 'c32b17e2-5aab-4ae0-8667-7169fb2cab34' },
  PDF_GENERATOR: { name: 'PDF Generator', guid: '33b1c35d-2cf3-4e5c-916c-260c421734ca' },
  PDF_MERGE: { name: 'PDF Merge', guid: '4f9b0e05-3b26-440b-b694-226dcfee3fda' },
  POWERFORM: { name: 'Powerform', guid: '322ffece-654f-49e4-bb5c-4ae41768d5be' },
  REST_CLIENT: { name: 'Rest Client', guid: 'de7dd43b-3845-40eb-b46f-9d3a2b751409' },
  SYSTEM: { name: 'System', guid: '35b989bf-bc68-487a-b1bb-d225b1ee6057' },
  SYSTEM_START: { name: 'System Start', guid: 'aa00f5eb-39de-407f-ba68-1ea3f24c7dc5' },
  TASK_ASSIGNER: { name: 'Task Assigner', guid: 'ff7f44b2-331b-4919-9290-43364ea1c69c' },
  TASK_SCHEDULER: { name: 'Task Scheduler', guid: '786edbd7-3ccd-42cf-82da-1ac265f7132d' },
  USER_PROFILE: { name: 'User Profile', guid: 'c2395aa9-ff66-48a3-985d-925093a59731' },
  WEB_SERVICE: { name: 'Web Service', guid: '8d74e181-6cfe-455e-8b25-837d5a21da7d' },
};

module.exports = taskTypes 
